import AmenitiesGrid from "@/components/site/AmenitiesGrid";
import FAQSection from "@/components/site/FAQSection";
import FinalCTA from "@/components/site/FinalCTA";
import SEO, { breadcrumbsLd, faqLd } from "@/components/site/SEO";
import { AMENITIES, FAQS } from "@/lib/site";

const HERO =
  "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwb2ZmaWNlJTIwbG91bmdlJTIwYXJlYXxlbnwwfHx8fDE3ODExOTEwNzR8MA&ixlib=rb-4.1.0&q=85";

const AmenitiesPage = () => (
  <>
    <SEO
      title="Office Amenities at Weston Commercial Center"
      description="Gigabit business internet, bookable conference rooms, on-site reception, covered parking, 24/7 access and more — every lease at Weston Commercial Center includes hospitality-grade amenities."
      path="/amenities"
      jsonLd={[
        breadcrumbsLd([
          { name: "Home", path: "/" },
          { name: "Amenities", path: "/amenities" },
        ]),
        faqLd(FAQS),
      ]}
    />
    <section className="bg-[var(--bg)] border-b border-[var(--border)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className="eyebrow">Amenities</div>
            <h1 className="hero-display text-[52px] md:text-[92px] mt-5 leading-[1.0]">
              Everything <em className="italic text-[var(--primary)]">already in place.</em>
            </h1>
            <p className="mt-7 text-[16px] max-w-xl leading-relaxed text-[var(--text-muted)]">
              Internet, coffee, conference rooms, parking, reception — the
              things that take weeks to set up on your own are switched on
              from the day you move in.
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="hairline aspect-[4/3] overflow-hidden">
              <img src={HERO} alt="Tenant lounge" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <AmenitiesGrid items={AMENITIES} />
    <FAQSection />
    <FinalCTA />
  </>
);

export default AmenitiesPage;
